<template>
  <div class="form-floating mb-3">
    <input
      :id="id"
      :name="name"
      :autocomplete="autocomplete"
      v-model="username"
      type="text"
      class="form-control form-control-lg"
      required
    />
    <label :for="id">{{ placeholder }}</label>
  </div>
</template>

<script>
export default {
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    autocomplete: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      default: 'Nombre de usuario',
    },
    value: {
      type: String,
      default: '',
    },
  },
  computed: {
    username: {
      set(newValue) {
        this.$emit('input', newValue);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>